import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaBrain, FaLungs, FaBone, FaLeaf, FaCircle, FaHandsHelping, FaSun } from 'react-icons/fa';
import bioresImage from './assets/Staff/Biores 2.jpg';
import cuppingImage from './assets/Staff/Cupping 1.png';
import bemerImage from './assets/Staff/Bemer 2.jpg';
import trTherapyImage from './assets/Staff/TR Therapy 2.jpg';
import swedishImage from './assets/Staff/Swedish 1.jpg';
import irTherapyImage from './assets/Staff/IR Therapy 2.jpg';
import hydroImage from './assets/Staff/Hydro.jpg';
import nlsImage from './assets/Staff/NSL 1.jpg';

const TreatmentsCards = () => {
  const treatments = [
    {
      id: 1,
      title: 'Bioresonance Therapy',
      description: 'Comprehensive bioresonance treatment with 7 specialized sub-treatments for various conditions.',
      icon: FaLeaf,
      path: '/therapy/bioresonance-therapy'
    },
    {
      id: 2,
      title: 'NLS Hunter',
      description: 'Advanced NLS Hunter therapy for comprehensive health analysis and treatment.',
      icon: FaHeart,
      path: '/therapy/nls-hunter',
      image: nlsImage
    },
    {
      id: 3,
      title: 'HydroVitality',
      description: 'Specialized hydrotherapy treatments for enhanced vitality and overall wellness.',
      icon: FaLungs,
      path: '/therapy/hydro-vitality',
      image: hydroImage
    },
    {
      id: 4,
      title: 'Targeted Radio Frequency',
      description: 'A new standard of comfort, warmth and body awareness using advanced radiofrequency technology.',
      icon: FaSun,
      path: '/therapy/tr-therapy',
      image: trTherapyImage
    },
    {
      id: 5,
      title: 'BEMER Sessions',
      description: 'Gentle support for your body\'s natural rhythm using patented European technology for microcirculation.',
      icon: FaHandsHelping,
      path: '/therapy/bemer-sessions',
      image: bemerImage
    },
    {
      id: 6,
      title: 'Red Light Sessions with Helios',
      description: 'Revolutionary red light therapy sessions using Helios technology for healing and wellness.',
      icon: FaBrain,
      path: '/therapy/red-light-sessions',
      image: irTherapyImage
    },
    {
      id: 7,
      title: 'Cupping Therapy',
      description: 'Traditional healing practice using gentle suction to promote circulation and relieve tension.',
      icon: FaCircle,
      path: '/therapy/cupping-therapy',
      image: cuppingImage
    },
    {
      id: 8,
      title: 'Swedish Massage',
      description: 'Traditional Swedish massage therapy for relaxation, stress relief, and muscle tension.',
      icon: FaBone,
      path: '/therapy/swedish-massage',
      image: swedishImage
    }
  ];

  return (
    <section id="treatment-services" className="py-16 bg-white scroll-mt-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-dark-grey mb-4" style={{ fontFamily: "Playfair Display, serif" }}>
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover our comprehensive range of BICOM bioresonance services designed to support your health and wellbeing journey
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {treatments.map((treatment) => (
            <div key={treatment.id} className="group relative">
              <div className="relative p-4">
                <Link to={treatment.path} className="block">
                  <div className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 border border-grey/20 h-full relative overflow-hidden group-hover:scale-105 min-h-[300px]">
                    {/* Background Image - always visible */}
                    <img 
                      src={treatment.image || bioresImage}
                      alt={treatment.title}
                      className="absolute inset-0 w-full h-full object-cover opacity-80 rounded-2xl z-0"
                    />
                    
                    {/* Treatment Name at Bottom - solid bar, no blur */}
                    <div className="absolute bottom-0 left-0 right-0 bg-white/95 rounded-b-2xl p-4 z-10 border-t border-grey/10">
                      <h3 className="text-xl font-semibold text-dark-grey text-center group-hover:text-gold transition-colors duration-300">
                        {treatment.title}
                      </h3>
                    </div>
                  </div>
                  
                  {/* Enhanced Creative Borders */}
                  <div className="absolute inset-0 border-4 border-gold/40 rounded-2xl transform rotate-2 group-hover:rotate-0 transition-transform duration-700 shadow-xl"></div>
                  <div className="absolute inset-3 border-2 border-white/60 rounded-2xl transform -rotate-1 group-hover:rotate-0 transition-transform duration-500"></div>
                  <div className="absolute inset-6 border border-gold/20 rounded-2xl transform rotate-1 group-hover:rotate-0 transition-transform duration-300"></div>
                </Link>
              </div>
              
              {/* Enhanced Floating Elements */}
              <div className="absolute top-6 right-6 w-3 h-3 bg-gradient-to-r from-gold to-yellow rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100 shadow-lg animate-pulse"></div>
              <div className="absolute bottom-6 left-6 w-2 h-2 bg-gradient-to-r from-blue to-purple rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-200 shadow-lg animate-pulse"></div>
              <div className="absolute top-1/2 right-4 w-1 h-1 bg-gradient-to-r from-green to-emerald rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-300 shadow-lg animate-pulse"></div>
              
              {/* Decorative Background Shapes */}
              <div className="absolute -top-2 -right-2 w-6 h-6 border-2 border-gold/30 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-400"></div>
              <div className="absolute -bottom-2 -left-2 w-4 h-4 border-2 border-blue/30 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-500"></div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gray-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-dark-grey mb-4" style={{ fontFamily: "Playfair Display, serif" }}>
              Ready to Start Your Healing Journey?
            </h3>
            <p className="text-gray-600 mb-6">
              Our experienced team is here to guide you through your bioresonance therapy journey. 
              Contact us today to schedule your consultation and discover how we can help you achieve optimal health.
            </p>
            <Link
              to="/therapy"
              className="inline-flex items-center bg-gradient-to-r from-gold to-yellow hover:from-yellow hover:to-gold text-black font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
              style={{
                boxShadow: '0 8px 20px rgba(184,139,68,0.3)'
              }}
            >
              View All Services
              <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TreatmentsCards;
